






























































import { Vue, Component, VueComponent, InjectComponent } from "@zoovu/runner-browser-api";
import { ProductRecommendationView } from "@zoovu/runner-web-design-base";

@Component({
  name: "ProductRecommendationView",
  mixins: [ProductRecommendationView],
})
export default class ProductRecommendationViewExtended extends Vue {
  @InjectComponent("ProductComparisonSelectorView")
  productComparisonSelectorView: VueComponent;

  @InjectComponent("ProductPriceView")
  productPriceView: VueComponent;
}
